import {
  GIVEBACK2019_DESKTOP_BREAKPOINT,
  GIVEBACK2019_MOBILE_BREAKPOINT,
  isInGiveback2019MobileViewport,
} from '@/utils/browser';
import { COLORS } from '@lemonade-hq/tokens';
import { clampedInversedLerp as cil, inversedLerp, lerp } from '@lemonade-hq/ts-helpers';
import { useEffect, useState } from 'react';
import styled, { css, keyframes } from 'styled-components';
import SVGPathSegment, { LARGE_ENOUGH_GAP } from '../GivebackShared/SVGPathSegment';
import SVGBear, { MobileSVGBear } from './shapes/SVGBear';
import SVGBeat, { MobileSVGBeat } from './shapes/SVGBeat';
import SVGBottle, { MobileSVGBottle } from './shapes/SVGBottle';
import SVGFlag, { MobileSVGFlag } from './shapes/SVGFlag';
import SVGGradients, { MobileSVGGradients } from './shapes/SVGGradients';
import SVGHands, { MobileSVGHands } from './shapes/SVGHands';
import SVGHead, { MobileSVGHead } from './shapes/SVGHead';
import SVGHeart, { MobileSVGHeart } from './shapes/SVGHeart';
import SVGOwl, { MobileSVGOwl } from './shapes/SVGOwl';
import SVGWorld, { MobileSVGWorld } from './shapes/SVGWorld';

export const VIEW_BOX_WIDTH = 1440;
export const VIEW_BOX_HEIGHT = 10820;
export const MOBILE_VIEW_BOX_WIDTH = 768;
export const MOBILE_VIEW_BOX_HEIGHT = 8192;
const DOT_SIZE_MULTIPLIER = 4;
const BASE_OFFSET = -57430;
const MOBILE_BASE_OFFSET = 0;
const DESKTOP_ANIMATION_OFFSET = 80;
const MOBILE_ANIMATION_OFFSET = 40;

const PATH =
  'M811,10695.39c-68.35,38.71-140.57-7.75-133.58-43.91,9.15-33.16,47.1-13.54,46.73,3.06-.17,8.36-6.73,7.9-6.71,0,0-29.62,55.85-28.24,43.91,10.17-21.31,70.67-248.11,96.94-353.86-43.53-48.42-64.32-31.29-150.32,49.05-145,.89.06,1.78.12,2.68.2,22.32,2,17.91,30.26.63,32.12a29.78,29.78,0,0,1-5.82.06c-16.79-1.53-30.81-15.56-35.35-31.79-3.32-11.85-2.26-24.53.54-36.52a129.25,129.25,0,0,1,167-93.1c20.54,6.89,41.71,23.61,39.69,45.18-1.12,11.9-9.44,22.22-19.61,28.5s-22.07,9.1-33.82,11.29c-91.64,17-187.47-3.11-269.64-47.1-176.52-94.5-240.36-253.8-240.36-253.8-85.8-195.86,139.94-351.86,121.57-252.86s61.25,238.54,159.29,258.15c41.91,8.38,89.42,40.87,112.43,102.17,3.06,8.17,5.93,16.59,8.59,25.19,4,12.92,16.9,13.05,19.78.47q3.28-14.35,6.23-27.81c14.48-66.11,28.71-134.09,30.22-202,.68-30.55-2.38-65.7-17-93.19-8-15-22.5-23.74-39.67-22.52-18.91,1.35-39.8,13-48.46,30.27-10.34,20.65-3.1,49,4.1,69.86,13,37.62,48.18,62.15,59.89,100,4.83,15.59,7.75,31.69,11.19,47.63.94,4.34,3.19,25.07,9.4,26.12,4.5.76,7.09-7.8,8.25-10.78,17.41-44.77,25.87-132,17.41-256.8-10-146.74-139.27-310.9-288.5-196.49-93.48,86.19-32.69,169.1,13.27,183.64,40.62,12.85,49.26-27.65,82.9-28.6,13.88-.39,22.53,11,33.18,17.7,12.24,7.7,28.74,12.43,43.09,13.17,19.54,1,38.58-6.68,49.28-23.49a83.61,83.61,0,0,0,12.6-47.84c-.67-14.08-5.11-27.57-8.9-41-3.49-12.4-8-26.28.25-37.91,5.81-8.2,18.4-7.88,27.32-9,7.32-.89,15.84-2.56,23.7-4.32,4.76-1.06,7,5.66,2.53,7.63-22.71,10-53.55,14.45-94.42,10.86-33.14-2.92-64.91,29.05-51.48,62.25,5.08,12.56,17.81,19.82,31,20.44,11,.51,22.33-2.87,30.29-10.43,25.35-20.81,9.66-51.17.45-58-7.19-2.49,2.24,27-10.19,25.62-7.08-.78-13.95-10.49-21.1-4.64a10.39,10.39,0,0,0-3.28,4.92,8.87,8.87,0,0,0-.09,5.95c1.28,3.07,5.12,4.39,8.4,3.86,17-2.75,23.37-30,9.44-39.94-10.5-7.46-17.34-11.4-43.39,3.87-29.41,17.24-26.6,63.66-38.68,64.81-12.08-1.14-9.27-47.56-38.69-64.81-26-15.27-32.88-11.33-43.38-3.87-13.94,10-7.57,37.19,9.44,39.94,3.28.53,7.11-.79,8.39-3.86a8.88,8.88,0,0,0-.08-5.93,10.37,10.37,0,0,0-3.28-4.93c-7.15-5.87-14,3.85-21.11,4.63-12.43,1.37-3.89-25.24-11.07-22.76-9.22,6.87-24,34.36,1.34,55.17,8,7.56,19.32,10.94,30.28,10.43,13.19-.62,25.92-7.88,31-20.44,13.44-33.2-18.34-65.17-51.48-62.25C128.76,9745.9,123,9650.15,148.2,9569c14.08-45.4,38.57-86.89,70.78-121.85,278.9-302.74,640.59-132.29,912.85-152.13l2.16-.11c29.73-1.56,60.45-5.66,87.77-18.1,17.63-8,36.23-20.64,44.51-38.83,8.49-18.65,1.13-40.24-15.09-52.06-22-16.07-53.44-14.06-78.37-7-21,6-41.3,16.58-63,18.7-26.66,2.6-53.15-9.26-66.39-33-12.48-22.39-12.39-50.33-5.18-74.38q27.12-90.45,249-189c92.61-49.74,88.14-116.83,67.65-164.83-15.81-37-49.3-60.42-85.85-60.42h-19.67l-10.65-13-11.54,22.94-14.2-123.68-12.43,221.43L1193,8669.07l-12.24,15.07L1165.89,8667l-12.43,9h-53.84L1089,8663l-11.54,22.94-14.2-123.68-12.42,221.43-7.5-114.59-12.23,15.07L1016.19,8667l-12.43,9H954.94l-10.65-13-11.54,22.94-14.2-123.68-12.42,221.43-7.5-117.59-12.23,15.07L871.51,8665a45.1,45.1,0,0,1-30,6.87c-34.91-4.43-67.72-22-92.41-50.55-36.23-41.9-71.29-107.84-65.44-202.18,3.76-60.57,27.06-118.2,70.94-160.73a257.05,257.05,0,0,1,86.68-55.13c27.74-10.63,57.73-17.56,82-35.58,22.68-16.87,33.7-48.8,22.17-75.28-14.38-33-51.65-46.59-85.5-45.7-64.21,1.69-123,43.3-168.8,84.68Q687,8135,683,8138.81C621,8197.05,560.34,8234,505.51,8251,411,8280.24,311.84,8221.65,290.61,8125c-8.17-37.17-13.27-85.61-4.7-138.63,13.61-84.12,85-119,77.06-102s-134.82,161.89-166.08,85c-25.24-62.08,25.68-72.73,44.93-67.15,23.72,4.74,49.87,53,17.26,77.77-61.39,46.64-90.12-52-51-73.1,24.9-13.45,76.84-45.33,110.14-66,19.27-12,44.89-3.09,52.21,18.4,1.21,3.57,1.56,6.44.5,8-4,5.78-15-12.88-22.82-28.3a37.07,37.07,0,0,1-3.16-23.1c20.71-120.56,33.22-162.45,37.53-162.1.58.05,1.25.51,1.16,1.08-25.15,113-39.1,168.05-41.15,176.89-9.06,14.76-29.49,20.36-36.89,14.25-13-10.78,33.76-101.21,43-126.09,8.73-23.42,16.6-59.22,23.94-80.87a17.41,17.41,0,0,1,17.67-11.75c22.73,1.48,39.43-9.66,51.12-13.24a11.4,11.4,0,0,1,13.35,6.32c56.14,131.25,118.92,189.47,116.19,230.5-1.41,21.23-12,32.31-25.64,36.77-21.92,7.2-48-4.94-52.09-27.68-16.13-90.54-42.2-203.46-37.29-206.94,5.7-.43,32.35,114.69,30.12,185-.73,22.91-.8,45.12-13.74,64l-60.59,88.63s-5.27,24-44.55,27c-59.63,4.59-69.31-76.75-18.51-96s105,92.21,18.51,96c-48.8,2.17-53.33-36.67-49.79-57.62a65.64,65.64,0,0,1,24.12-40.35c32.32-25.66,116.24-91.49,116.7-84.17.27,4.36-10.75,12.24-23.4,19.31-27.52,15.41-60.19-.36-65.41-31.49-3.87-23,2.51-43.1,2.81-49.3.51-10.43-11.83,2.48-2.77,3,8.31.5,5.54-15.12,13.77-38.3,14.12-39.76,33.19-90.94,20.39-112-9-14.24-42.47-.11-72.31-38.37-23.29-31-15.86-69.15-9.63-79.36s10.35,3.27-3.46,14.57c-10.1,8.27-45.63-18.84-22.19-53.72,21-29.15,53.47-24.36,67.35-9,9.57,10.58,2.14,30.33-3.74,24.92-10-9.18,57.17-23.37,20.4-1.14-38.79,23.45-33.62,75.25-26.82,90.14,1,5.92,13.07,4.84,12.22-3.67-.6-6.12-3.13-7.81-6.06-7.6-9.4.67-6.16,11.27-6.16,11.27,25.5,68,97.07,43.65,116.34-.57s-1.2-68.75-6.23-72.56c-7.16-5.42-17.73-1.52-14,13a29.06,29.06,0,0,0,39.11,19.38c13.18-5.41,24.5-17.93,23.61-34.06-1.71-30.61-38.54-49.87-70.83-35.14s-17.08,30-11.9,27.19c1.32-.72,4-6.91-3.13-13.15a94.27,94.27,0,0,1-20-25.45A105,105,0,0,1,393.53,7408c-4.48-89.85.58-223.2,2.33-292.12a31.64,31.64,0,0,0-31.59-32.42c-5.6,0-11.45.06-17.87.33-47.65,2-94,16.84-133.37,43.74-209.41,142.13,664.63,317.89,993.45,102.53a132.59,132.59,0,0,0,37.45-36.54c65.79-97.45-107.13-130.31-158.76-173.68-92.65-71.44-32-361.53-22.65-358.88,6.44,1.82,19,8.48,37.1,13.53a431.14,431.14,0,0,0,47.55,10.46c11.23,1.81,33.7,5.23,34.13,1.33.13-1.11-11-3.58-16.08-2.87-9.77.53-18.47,11.76-18.88,21.24-.46,12.29,33,2.77,34.8,1.45a4.34,4.34,0,0,0,1.62-4.38c-1.21-5.79.85-13,4-14.76,6.11-5.48,30.88-2.71,30.87-18.84,0-10.11,5.29-10.18,3.56-1-.24,1.3-.52,3.44-.65,4.75-1.38,13.64-17.68,13-27.61,16-3.74,1.17-6.6,3.18-7.41,7.6a18.21,18.21,0,0,0,0,6.26c2.3,7.53,5.27,15.42,13,14.18,3.75-.6,13-13.31,15-15.55,22.12-28.69,15.14-39.66,15.14-39.66,14.59-.53,25.17-7.36,24.93-17.24-.36-14.31-14.09-12.2-26.78-13.78-25.37-3.16-83-16.51-83-16.51l-17.5-3.86a15.57,15.57,0,0,0-16.6,6.93c-4.34,7-12.38,15.24-26.18,15.65-6.45.15-7.32-6.36-2.23-4.75,7.1,2.24,88.76,29.31,147.35,33.56,1.29,7.42,2.84,15,11.58,18.67a7.06,7.06,0,0,0,8.87-3c7.28-12.94,17.45-49.57,20.34-64.82,2.2-11.52.86-26.65.54-35.95-.29-8.46,0-20.53-1.34-28.86-6.84-3.76-15.78-7.1-21-12.37a78.47,78.47,0,0,1-9.14-11.56c-2.42-3.62-7.92-16.12-9.34-20.35-5.32-17.46-11.4-34-24.5-46.7-3-3-6.61-5.95-8.76-9.5a2,2,0,0,1,2.84-2.57c7.69,5.68,14.57,12.53,19,21,8.26,15.56,7.84,34.06,16.19,49.65,7.58,14.14,19.09,27.18,34.66,32.45,5.11,1.73,24.17.14,17.56-11.77-4.82-8.68-13-45.52-17.16-73.83a26.65,26.65,0,0,0-1.61-5.94c-9.06-22.41-19.22-40.83-21.45-47.25-5.66-16.26-45.25-22.62-58-33.93s-29.65-13.22-30-3.18c.35,6.36,18.66-.95,20.08-3.78,1.2-2.41-.37-9.54-.86-18.6a3.68,3.68,0,0,0-4.68-3.37c-22.43,6.55-66.08,8.38-79.94,12.67,7.07,23.33-9.65,92.12-2.13,84.13,5.66-6,7.08-54.44,2.13-84.13-1.38-21.32-28.84-9.19-24.49,1.9a2.57,2.57,0,0,0,1.64,1.58c4.35,1.21,7.88-10.55-1.19-26.1-9.9-17-45.44-11.26-56.85,20.66-14.2,37.5,48.89,73.19,41.92,75.95-35.45-11.51-11.31,41.16,0,40.45,4.6-2.56-24-32.43-13.88-39.5s42.24,8.48,47.9,19.79,25.45,45.25,39.59,55.85-1.41,23.33-9.19,25.45c-6,1.64,2-9.33,10.44-13.43a8.86,8.86,0,0,1,10.44,2c6.15,6.83,15.38,18.15,1.75,22.42-6.6,2.57,3.53-14.55,21.21,4.54,14,15,46,13.73,66.42,18.92.15-11.49-.73-32.5-3.14-28.56-3.18,5.22,3.14,27.27,3.14,28.33v.23l1.19.3c12.52,3.17,19,9.77,17.23,20.37-6,21.56-103.76-12.55-102.52-5.66,16.23,11,116,7.25,105.38,37.32-3.92,4.92-9.57,7.58-24.24,5.81-18.05-2-44.2-9.09-93.18-19.26-13.18-2.74-10.58-12.07-17.08-22.14,31.95.26,29.3-43.35-1.46-38.31-18.43,4.11-15.73,23.77-14,24.25,6.45-17.8-20.42-25.67-31.82-13.65-7,8.2-5.43,24,8.49,31.29,3.59,27.82,37.71,21.55,38.51,2,0-1.06.37-11.82-9.17-17.66-7-4.69-27.49-3-29.34,15.65-4.78,2.38-15.38,1.85-23.66-10.34-9.75-14.06-1.71-51.52,4.78-46.58s-3.66,34.64-9.32,41.71-36.06-38.17-6.36,4.25,21.21,84.83,8.48,94.73-20.5-4.95-27.57-26.86-51.87-66.24-59.87-75.65c-9.78-11.49-6.59-50.9-10.84-69.28s8.49-29.69,10.61-26.16-11.31,14.85-11.31,14.85C897.6,6425,842.62,6386.75,809.91,6359.74c-221-192.29-53.12-316.65,47.59-291.12,62.8,15.92,56.5,20.41,149.48,48.5a106.82,106.82,0,0,0,56.83,1.7c25.58-6.43,48-22.25,60.25-48,14.49-30.45,10-69.91-11.47-96.08-21.84-26.6-59.71-28.61-89.9-39.8-24.55-9.1-48.38-19.18-67.1-38.18-43.55-44.21-61.17-118-55.35-176.24C904,5683.29,933.57,5640,964.61,5620c26-16.74,86.57-31.6,103.12,13.82,3.21,8.79,18.93,97.81-165.26,53.9-47.41-11.21-42.79-30.51-60.43-41.79-13.35-8.55-31.85-5.29-40.4,18.52s-17,22.06-20.47,20.48c-3.07-1.41-3.4-5.36-3.29-8.31a37.5,37.5,0,0,1,.64-5.28c.35-1.88,1-3.75.94-5.69a3.72,3.72,0,0,0-2.63-3.58c-1.68-.42-3.2.53-4.35,1.66-2.52,2.46-3.41,6.09-4.91,9.13-1.15,2.34-2.36,4.64-3.66,6.89a49,49,0,0,1-6.68,9.36c-1.92,2-4.49,4.21-7.45,4.21-16-2.14-5.22-39.23-1.61-52.68s11.13-5,9.19,1.69-8.84,12-23,18.55-37.82,10.05-49.91-2c-5.38-5.37-11.72-2.3-13.64,3.46S668,5686.72,685,5682.13s28-39.05,18.64-46.47-18.46,2.61-23.43,10.3-12.17,8.36-19.38,4.55c-5.73-3-8.54-5.7-13.69-8s-13.15.4-16.3,8.72c-2.84,7.52-7.63,25.51-15.32,37s-15.25-2.85-14-16.18c0-1.77.32-4,.16-5.92a3.2,3.2,0,0,0-5.5-2c-7.61,7.83-23.4,34.78-36.41,34.78a7.88,7.88,0,0,1-6.37-3.95c-5.44-8.9-1.13-23.83,1.1-33.08,1.48-6.1,3.42-12.07,5.09-18.11,1.26-4.57,3.11-9.28,7-12.45a5.49,5.49,0,0,1,2.08-1.1c3.76-1,5.14,2.49,4.57,5.22-1.79,8.56-8.49,17.34-13.52,24.27a114.5,114.5,0,0,1-23.14,23.85c-13.06,9.94-28.56,16.51-44.18,20.76-35.26,9.61-76.22,13-110.93-.65-72.34-28.38-67-116-9.34-156.5,79.37-55.74,181.56-57.92,270.27-89.82,82.6-29.71,92.44-85,80.44-107s-55.63-24.7-130.94-4.55c-118.09,25.75-226.17-64.45-240.46-108s14.79-51.29,2.52-80.56a28.61,28.61,0,0,1-2-15.37c2.45-16.13,23.6-22.42,34.17-28A5,5,0,0,0,386,5105c-6.65-3.31-11.6-5.61-13-6.22-17.1-7.38-39.15-25.85-52.52-39.88-11.46-12-34.13-54.53-33.46-77-.69-16.57,10.58-42,11-58.56.11-4.74-1.18-10.94-5.9-11.48-4-.46-6,1.89-7,5.48-6,20.54-5.49,54.77,23.89,54.4a227.21,227.21,0,0,0,32-3.09c8.69-1.4,17.62-3.45,24.56-8.85s11.3-15,8.12-23.2c-4-10.34-17.2-13.51-28.29-12.93s-17.19,1.49-27.48-2.69c-14.4-5.85-26.89-22.7-21.88-37.39,17.7-52,28.73,23.7,47.84-36.84a17.34,17.34,0,0,1,12.09-11.62c7.5-2,11,2.13,23.74,7.38,17,7,27.8,24.07,33.79,41.43,10.27,29.81,9.48,61.35-11.43,88.12-3.57,4.57-15.11,23.6-13.42,29.14,4.34,14.17,16.57-4.34,24.11.68,8.77,5.83,2.68,17.66-1.23,25.65s-9.94,14.71-15.11,21.95c-7.2,10.08-13,22.39-10.5,34.52,2.86,13.93,12.9,27,26.8,30.18a211.73,211.73,0,0,0,58.8,3.85,5.44,5.44,0,0,0,1.84-10.35c-10-4.6-21.06-7.55-29-15.61-5.72-5.82-13-17.42,0-22.26a5.77,5.77,0,0,1,7.92,4.44c1,6.27-9.82,3.95-13.36-.86-3.13-4.23-4.27-7.47-2.91-12.55,1.23-4.58,5.47-8.75,9.63-11,5.46-3,12.66-.36,16.74,4.36s5.79,11,7.37,17c3.59,13.68,9.59,30.69,21.25,38.38a12.91,12.91,0,0,0,9.88,1.85c11.07-2.43,19-6.78,27.86-11,20.59-9.75,36-22.7,50-38.85a4,4,0,0,0-4.47-6.24,31.28,31.28,0,0,0-9.84,6.86c-5.39,5.42-9.51,12.08-15.42,16.94s-14.64,7.6-21.21,3.68c-4-2.39-6.39-6.72-9.93-9.75-4.62-4-10.8-5.41-16.6-7.28s-11.84-4.62-14.75-10c-2.52-4.64-1.14-13.71,5.18-14.26,3.2-.27,8,1.72,11.41,2.07a64.15,64.15,0,0,0,13.07.18c9.2-.92,18.53-4.85,23.85-12.4,6.16-8.74,5.89-20.28,8.63-30.6s11.91-21.13,22.22-18.27c5.76,1.6,9.6,7,12.25,12.34,6,12.19,5.72,30.71,3,46.2a3.23,3.23,0,0,0,5.87,2.36c4.1-6.14,8.09-13.6,11.08-18.6,5.14-8.58,14-33.24,15.59-43.11,9.07-57.88-9.22-107.64-46.56-152.85-3.19-3.86-7.2-7.93-12.21-7.84-5.82.1-10.07,6-10.86,11.76s.84,11.53,1.5,17.31c2.55,22.18-6.3,49.78-17.56,69.08L514,4951.55c-4.41,7.56-9.19,15.49-16.9,19.67s-19.21,2.69-22.85-5.27c-2-4.37-1.37-9.88-4.43-13.59-4.87-5.91-14.48-2.83-21.81-5.08-11.3-3.47-14.11-18.5-11.39-30C437.9,4912,444,4904,450,4895.82a54.87,54.87,0,0,0,9.86-42.25c-8.15-45.27,7.52-52.23,14.7-53.49,23-4,26.44,43.7,56.94,28.9,8-3.89,20.09-5.71,18.13-15.36a12.29,12.29,0,0,0-5.5-7.78c-31-20.07-70.32-32-107.06-26.52-35.26,5.21-70.13,9.74-119.55,65.54l.14-.14c-142.8,188.71,298.44,263.47,260.64,332.79S51,5204.4,113.67,5023.27s786-100,715.43-14.23-824,19.36-715.43-157.6,698.43-112.89,689.43-51.66S-56,4785.32,163.65,4674.47,887,4569.9,818.33,4661.59s-676.47-40-597.4-161.58c27.19-41.81,95-63.44,174.6-72.34,151.92-17,347,12.35,385.62,36.12,58.91,36.22-406.79-11.47-301.07-84.78,65.07-45.13,220.86-14,383.22-45.89,160.05-31.45,260.81-192.43,215.27-349-12.86-44.22-37.16-86.31-80.74-114.82-55.21-36.12-128.11,10.19-117.34,75.28.12.77.26,1.54.41,2.32,8.05,41.13,39,76.9,77.29,96.14,37.38,18.77,81,17.84,121.86,5.87,82.89-24.28,132.63-99.31,126-186a215.91,215.91,0,0,0-9.73-50.61c-32.52-99.31-27.59-192.57-4.79-179.52,5.87,3.36,6.37,23.71,6.87,29.15,2,21.35-.48,43.48-8.47,63.46-26.08,65.21-114,91.34-179.77,64.38-48.08-19.72-71.89-93.65-69.66-117.16a9.07,9.07,0,0,1,9-8.1c5.81.17,3,6.64,1.52,7.46-8.61,4.9-10.6-4.29-30.19,5.45a12.59,12.59,0,0,1-14.84-2.59,9,9,0,0,1-2.68-6.92c1.52-17,21.82-37.64,18.68-101.39a130.71,130.71,0,0,1,8.39-37c23.18-59.87,50.32-69.87,77.59-75.42,52.68-14.22,47,11.08,87.78-9,10.54-5.18,22.32-7.44,33.22-3.07a22.28,22.28,0,0,1,4.12,2.1c7.29,5,12.61,13.18,12.76,22s-4.85,17.21-11.26,23.39c-12.15,11.71-29,17.11-45.57,20.35s-33.58,4.7-49.53,10.23-31.22,16-37.49,31.62c-2.62,6.51-3.37,14.45.73,20.14a23.55,23.55,0,0,0,7.65,6.27c6.29,3.62,13.69,6.33,20.74,4.6,11.23-2.75,19-16,30.49-15.11,4.91.36,9.52,3.4,14.41,2.84s7.07-6.89,7.92-10.91a35.85,35.85,0,0,1,6.21-13.9c4.75-6.37,12.94-9.25,19-2.84,4.54,4.77,6.55,11.2,10.11,16.62,4,6.09,12.79,10.81,18.27,5.23a10.21,10.21,0,0,0,2.68-7.73c-.31-6.38-4.27-11.32-6.61-16.92-6.88-16.43,1.25-35.71,13.52-48.64,6.73-7.09,15.67-13.32,25.43-12.61,10.06.73,18.1,8.56,24,16.69,9.61,13.16,16.39,28.87,16.51,45.15.2,26.53-17.7,50.94-40.82,64s-50.63,16.31-77.18,15.26c-14-.56-28.35-2.31-41.08-8.29s-23.79-16.74-27.28-30.34c-4.22-16.47,3.17-33.83,13.3-47.49s23.06-25.15,32.48-39.31,15-32.57,8.32-48.2c-3.68-8.61-11.62-15.89-21-16.58-11.41-.84-21.4,8-27.33,17.71-8,13.13-11.23,28.81-10.8,44.17s4.37,30.45,9.93,44.78a10.4,10.4,0,0,0,2.78,4.55c2.65,2.12,6.48,1.27,9.86,1.43,14.1.69,21.41,19.5,35.36,21.65,5.36.82,10.33-1.26,14.11-5a25.79,25.79,0,0,0,4.86-6.34c1.29-2.49,2.16-5.31,4.33-7.23,3.4-3,8.66-2.77,12.87-2.27,7.67.91,14.87,4,22.51,5.09,9,1.22,18-.67,27.06-.57a11.74,11.74,0,0,1,6.34,1.39c2.41,1.55,3.5,4.48,4.19,7.26,5.15,20.67-8.54,31-26.21,43-42.36,20.95-81.81-2.72-84.46-17.39-2.41-13.4,2.62-27.19,10.18-38.52s17.57-20.77,26.61-31c9.19-10.35,17.92-23.8,14.18-37.12-2.44-8.68-10.06-15.33-18.64-18.14s-18-2.21-26.74.05c-8.29,2.13-16.86,6.35-20.36,14.15-4.9,10.91,2.18,23.43,10.34,32.18a115.6,115.6,0,0,0,66.78,35.2c10.93,1.65,22.28,1.68,32.83-1.58,12.16-3.77,22.7-11.75,31.15-21.26,18.55-20.87,28.13-35.15,37.23-73.78,16.53-70.24,9.38-142.67-44.07-195.32-32.2-31.72-74.86-51.55-119.06-61-65.07-13.91-132.59-8.16-196,10.36-51.27,15-99.51,41.32-150,59.25-135.26,48-144.39-42.63-217-77.66s-116,20.93-202.38,41.64-117.42-35.44-122.75-83,36.08-203.67,45.44-298.68,46.48-201.9,33.38-201.28c-10.94.52-25.14,72.48-29,136.24a52.4,52.4,0,0,0,36.15,53c29,9.39,53.86,7.65,95.15,6.08,57.4-2.19,81.73-5.73,81.73,14.17,0,9.06-32.06,22.08-56.7.83-15.12-13,5.61-20,3.74-9.38s-27.76,15.94-8.11,55c17.76,35.3,88.69,47.81,123.34,45a9.81,9.81,0,0,0,9-10.78c-6.24-63.88,37.24-150.73,42.91-162.41,5.93-12.19-9.31-10.65-34.58-9.71s-39.49-2.56-35.84-8.9c-7,13.15-42.39,75.28-42.08,96.43.69,3.86,6.24,4.07,6.24-4.06,0-46.76,52.28-100.78,42-124.39-10.61-24.38-53.66-12.5-161-13.13s-113-121.62-112.95-128.18c0-18,3-39.25,8.75-54.88C306,2298,615.21,2340.1,638.89,2432c19.71,76.46-82.28,119.12-166.23,50.16-135.58-111.36-21.29-270.77,111.64-258.45,131.26,12.17,130.05,118.55,305.87,128.93a259,259,0,0,0,104.19-14.8q103.68-37.89,136.91-150.9c17.28-70.44,25.35-151.93-73.39-227.93Q959.13,1883,875,1841c-108-76.52,54.06-170.58,92.37-249.1,43.39-88.94,197.33-141.84,293.8-138.74,78.45,2.51,82.88-28.16,77.06-43.58-8.55-22.63-24.59-18.15-37.84-30.87-12.62-12.1,2.57-21.74-13.9-39.66-12.1-13.12-29.43-3.87-39.4-23.8-17.59-35.22-49.78-26.58-103.08,17.19s-21.37,67.83-114.92,105.57S875.54,1558.79,875,1625.19c-.13,16.87,9.07,23.64,15.58,34.21s16.07,4.6,10.59-2c-7.42-8.92-25.14-20.12-32.68-14.09s7,26.66,15.59,32.19,9.07-2.51-3-13.61c-11.51-10.59-13.87-5.55-39.85,12.42a9.43,9.43,0,0,0-4.09,7.65c-.35,51.76,54.2,73.59,63.7,68.47,11-18.8-34.24-72.83-56.93-74.77a6.37,6.37,0,0,0-6.9,6.16c-1.16,44.25,45.11,71.85,63.81,68.67,5.68-2.49,3.83-3,18.86-20.7a15.13,15.13,0,0,0,3.48-12.23c-3.36-20.27-18.9-31.1-18.47-23.91.51,8,27.15,33.19,31.68,22.13s-15.12-42.76-20.11-37.23c-3,3.36,9.27,15.43,19.42,24.39,6.26,5.53,23.15,3.82,23.31,3.78,117.19-8.07,185.68-109.72,209.16-147.91,24.14-39.23,87.3-41,124.23-62.38,25.14-14.58,57.18-55.43,57.18-95.59,0,0,8-230.28-170.44-216-11,.89-83.65,14.09-109.22,18.18a134.61,134.61,0,0,1-26.7,1.08c-31.28-1.27-62.21-8.38-91.53-19-15.25-5.54-40.16-15.63-54.28-26.22-9.75-7.31-23.58-20.46-28.35-32.86-28.07-73,69.78-125.68,128.23-87.38,14.24,9.33,23,18.08,30.43,33.19s12,30,13.09,46.68c5.89,87.83-88.43,155.11-170.21,149.29-24.48-1.75-39-7.43-60.88-18.5C763.79,1226,724.1,1182,698.84,1137.73c-22.78-39.94-40.56-78.78-74-111.6-64.57-63.38-148.07-85.83-236.93-76.35-56.53,6-113.09,35-133.47,90.53-11.66,31.8-11.14,70.12,4.21,100.68,35,69.66,95.76,100.87,170.21,117.85,149.51,34.1,281.23,7.63,421-48.86,41.67-16.85,106.58-48.46,147.35-74.2,73.93-46.68,120.07-76.68,184.36-147.38,41.54-49.59,44-92.36,6.89-117.67a83.64,83.64,0,0,0-45.07-14.16c-13.65-.36-27.3-1.24-41-.79-23.14.76-36-19.11-42.14-38.9-9.15-29.61-8.56-72.19,18.7-90.76,21.14-14.41,44.71-3.11,55.9,19.13,10.13,20.13,11.78,46,5.56,66.61-5.26,17.42-16.13,43.92-38,43.92-30.15,0-41.29-21.33-47.32-60.75-5.78,18.49-27.39,24.92-42.88,27.14-10.66,1.53-18.73,9.22-21.89,20.75-2.66,9.67-1.16,19.55,3.75,19.55,10.1,0,8.87-137.31,3.2-136.8-4.41.4-14.49,76,18.91,76,7.81,0,7.29-6,5.39-7.25-6.14-4-18,.63-20.66.87-15.88,1.44-40.93,5.21-56.59,1.35-5.57-1.38-11.51-4-13.73-9.31-5.79-13.8,10.89-33,15.37-45.35,4.69-12.87-2.61-18.16-12.19-20.25a42.58,42.58,0,0,0-21.88,1.19c-12.45,3.92-39.25,10.15-61.8.33A18.35,18.35,0,0,0,825.39,734q-3.09,8.88-6.2,17.77c-3.11,8.91-8.4,19-9.71,28.26a10.15,10.15,0,0,0,.53,5.24c2.16,5.38,7.77,5.75,12.65,5.59,14.25-.48,27.83-.63,38.84,9.81A32.39,32.39,0,0,1,870.4,833c-9.43,34.23-72.38,41.43-88.56,9.11-1.27-2.52-4-7.5-1-9.87a3.69,3.69,0,0,1,5.94,2.53c.11,2.26-1.41,4.23-2.89,5.93-14.59,16.71-33.09,23-54.81,18.85-5.07-1-28.54-11-29.64-1.21-.25,2.27,4.23,3.82,7.8,4.16,6.84.65,19.44,1.76,22.45-6.36,1-2.78.93-5.84.83-8.8-.86-26-.19-52,1.17-77.91.55-10.53,1.2-21.08,2.49-31.55.21-1.68,2.71-19.54,5.8-15.91,2.43,2.86,1.25,7.21-.18,10.68-17.14,41.41-52.8,74.7-89,99.78-16.35,11.33-34,22.16-52.88,28.73-4,1.41-22.95,7.92-21.35-2.41.83-5.39,11.45-.93,15.25,0,24.35,6,55.55-.3,62.7-28,4.58-17.77-4.62-35.39-19.61-44.9-3.19-2-30.93-15.15-32.93-6.54-.82,3.5,16.49,4.57,31-2.44,18.39-8.85,23.7-32.84,9.95-47.92a28.37,28.37,0,0,0-16.86-9A41.77,41.77,0,0,0,594.66,726c-25.12,16.8-21.93,51.35-32.36,76.47-5.89,14.16-14.75,27.36-27,36.59a68.72,68.72,0,0,1-35.25,13.52c-8.31.73-16.94-.15-24.38-3.91-10.1-5.11-17.08-15.18-20.31-26-4.09-13.74-2.22-29.76,7.19-40.56,6.92-7.93,17.37-12.42,27.89-12.94,18.08-.9,36.15,10.29,43.4,26.86,12.81,29.29-10.13,64.11-42.52,62.2-31.62-1.86-46.91-29.28-47.27-56.77-.39-30.45,6.35-71,34.91-88.31,14.56-8.8,31.19-8.68,45.25-.1a10.5,10.5,0,0,1,3.76,3.7c5.21,9.08-8.5,16.57-21,7.87-94.14-60.47-154.44,7-131.82,8.18,12.93.66-5-44.8-47.41-40.59-17.79,1.77-28.37,9.58-36.1,21.85s-7.88,29.61,1.58,40.61c6.47,7.52,16.26,11.28,25.9,13.63,18.8,4.57,34.67,5.84,47.12,22.36,6.55,8.69,9.61,20.39,7,31.08-5.28,21.25-25.26,27.76-43.91,29.18-12.24.93-24.45-.49-36.44-3-5.66-1.2-12-3.37-13-9.88a11.12,11.12,0,0,1,2.64-8.71c9.45-11.31,27.5-8.93,37.17,1.11,8.61,8.94,11.27,22.35,9.72,34.67-.5,4-2.38,8.9-6.52,9a5.47,5.47,0,0,1-4-1.78c-3-3.1-2.27-6.93-2.34-10.6C314.3,752.08,327.88,684,337.85,649.35a123.87,123.87,0,0,1,44.26-65c139-104.46,411.81,110.13,449.65,47,21.24-57.15-130.93-10.57-113.24-212';

const MOBILE_PATH =
  'M384.32,341.26v38.13c0,52.11,35.87,46.29,29.51,63.45-11.52,19.28-95.82-48.76-136.72-13.58a41,41,0,0,0-8.44,10.24l-.49.87c-9.8,16.58-7.34,45.13-8.78,67.21a5.38,5.38,0,0,0,.17,2.22,1.82,1.82,0,0,0,1.72,1.24c1.11-.09,1.61-1.41,1.73-2.51.43-3.45-.32-7.19-2.73-9.69-2.66-2.77-7.6-3.45-10.28-.46a3.27,3.27,0,0,0-.86,2.44c.21,1.93,2,2.58,3.66,2.9a32.74,32.74,0,0,0,16.07-.14c2-.5,5.18-1.54,6.9-4.23s1.2-6.45,0-9.32c-1.49-3.59-3.78-4.9-7.32-6.38a26,26,0,0,0-5.47-1.6c-4.71-.86-10.79-2.24-12-8.36a10.58,10.58,0,0,1,1.77-7.89,12.3,12.3,0,0,1,9.78-5.61C274.4,459,281,469.83,277,470.53c-7.15-1.3,6.78-18.33,24.53-14.87a21.56,21.56,0,0,1,15.06,11.75c.2.41.35.76.45,1,1.13,2.81,6,1.33,2.06-1.37s-10-3.51-14.22-.94c-8,4.84-10.2,15.44-10.09,23.95.11,7.69,4.71,16.1,13.55,16.63,9.07.53,15.51-9.22,11.9-17.4a12.94,12.94,0,0,0-12.14-7.56,11.1,11.1,0,0,0-7.81,3.63c-2.58,3-3.15,7.5-2,11.34A11.84,11.84,0,0,0,304,504a12.74,12.74,0,0,0,6.83,1.1,19.19,19.19,0,0,0,9.9-3.79A24.44,24.44,0,0,0,328.26,491c2.92-7,2-16.68,9-21.38a11.72,11.72,0,0,1,8.79-1.73,8,8,0,0,1,4.53,2.32,8.21,8.21,0,0,1,.29,11.6,8.11,8.11,0,0,1-2.24,1.66c-4.18,2.33-9.62,3.76-9.33,1,.58-4.42,8.32,1.27,9.21,1.83,4.2,2.66,6.77,7.59,5.49,12.55-2,7.76-10.73,9.48-17.55,7.84-1.06-.25-4-1.49-4.26,0-.45,2.89,4.84,1.07,6,.69a63.6,63.6,0,0,0,14.8-8c10.34-7.15,24.27-15.28,26.32-27.46.25-.65.52-3-1.18-3.12-1.78-.41-1.73,3.64-1.81,4.14-.37,2.93-.55,5.88-.7,8.82-.38,7.26-.57,14.52-.33,21.79A6.35,6.35,0,0,1,375,506c-.86,2.27-4.36,2-6.28,1.78-1-.1-2.25-.53-2.19-1.17.32-2.75,6.9.07,8.3.34a15.34,15.34,0,0,0,15.33-5.27A2.38,2.38,0,0,0,391,500a1,1,0,0,0-1.07-.93h-.06a1.16,1.16,0,0,0-.53.21c-.86.67-.07,2.06.29,2.77,4.53,9,22.14,7,24.78-2.59a9.06,9.06,0,0,0-2.49-9c-3.09-2.92-6.89-2.88-10.87-2.75a4,4,0,0,1-3.06-.8,2.8,2.8,0,0,1-.61-2.36c.4-2.58,1.85-5.32,2.7-7.75l1.72-5a5.64,5.64,0,0,1,5.34-3.8H428c4,0,9.54.63,7.57,6-1.24,3.44-5.8,8.69-4.36,12.54a4.25,4.25,0,0,0,2.71,2.41c4.73,1.51,9.81.95,14.65.52.73-.07,7.71-1.05,7.91-.27a4.41,4.41,0,0,1-1.5.71c-8.82,3.07-6.32-22.88-5.07-23,1.58-.15,1.93,40.77-.87,40.77-1.38,0-1.24-2.79-.77-5.56a6.94,6.94,0,0,1,5.85-5.71c4.31-.62,10.34-2.42,12-7.58,1.72,11,4.8,17,13.23,17,6.13,0,9.17-7.41,10.64-12.28,1.73-5.76,2.66-12.67-.18-18.29-3.12-6.22-10.74-9.13-17-5.69-9,4.94-7.75,17.1-5.23,25.38,1.73,5.53,5.32,11.09,11.79,10.88,5.17-.17,10.4.35,15.6.24,21.35,1.34,28.67,10.72,20,22.66a27.93,27.93,0,0,1-12.26,9.39c-5.92,2.38-16.58,5.89-34.56,9.59-8.84,1.81-17.73,4.4-25.55,8.91s-4.67,14.28,1.17,17.42c12.64,6.83,27.48,10,38.62,19.11,7.28,5.93,10.17,13.72,11.21,22,1,4.22.77,21.45.77,25.11,0,16-12.77,32.25-22.78,38.06-14.72,8.53-39.89,9.21-49.5,24.84-9.36,15.2-36.65,55.68-83.35,58.89-.07,0-6.79.7-9.29-1.5-4-3.57-8.94-8.37-7.75-9.71,2-2.21,9.82,10.41,8,14.82s-12.49-5.5-12.7-8.69c-.17-2.86,6,1.46,7.36,9.52a6,6,0,0,1-1.39,4.87c-6,7-5.25,7.25-7.51,8.25-7.46,1.29-25.86-9.7-25.46-27.32a2.48,2.48,0,0,1,.86-1.81,2.51,2.51,0,0,1,1.9-.64c9,.77,27.05,22.32,22.65,29.77-.74,1.26-5.35-.43-6.2-.74a30.35,30.35,0,0,1-9.86-6c-5.84-5.23-10.89-13.6-8.08-21.64,2.31-6.61,11.32-10.57,16.86-6.29a9.27,9.27,0,0,1,3.45,5.72A14.53,14.53,0,0,1,302,740.34c-.34-1.44-.39-3.18,1.35-3.9a3.57,3.57,0,0,1,2.07-.14,17.85,17.85,0,0,1,10.18,6.46c.45.58.9,1.3.39,2.07a1.79,1.79,0,0,1-2.5.36c-5.6-3.89-8.3-10.86-8.38-17.61-.08-6.33,1.9-12.52,4.41-18.33a99.27,99.27,0,0,1,45.7-48.61c11.85-6,25.26-9.87,34.68-19.25,5.66-5.63,9.43-12.85,14.25-19.21A70.68,70.68,0,0,1,431.9,600.3c5.62-2.49,12.86-4,17.38.2,2.56,2.37,3.57,6.06,6.09,8.47,4.7,4.5,13.8,3.93,16.2,10,1.11,2.77.23,6,1.07,8.85,2.44,8.33,16.54,7.94,17.93,17.75a11.35,11.35,0,0,1-4.29,10.23c-6.11,5.08-14,4.84-21.53,4.93a203.34,203.34,0,0,0-54.85,8.2c-21.82,6.41-43.1,17-58,34.13-9.51,11-16.07,24.26-25.41,35.39-7.92,9.42-17.76,17.22-24.76,27.35-4.84,7-8.57,15.13-7.71,23.84.91,9.19,6.17,16.08,13.31,21.49,14.79,11.21,31.42,12.92,49.42,11.24,22.24-2.09,105.48-44.91,112.42-48,9.35-4.2,19.62-6.07,29.33-1.84a14.39,14.39,0,0,1,3,1.78A20.29,20.29,0,0,1,509,794.19c-1.14,6.12-5.17,11-9.4,15.59a55,55,0,0,0-13.12,24.14c-10.41,42.92,39.74,64.78,52.71,69.65,61.57,24.86,82,98.12,75.22,159-7.84,59.11-63.71,121-176.77,131.6-20.75,1.34-81.15-4.72-87.27-31.67a12.81,12.81,0,0,1,2.8-11.57,11.74,11.74,0,0,1,5.38-3.38,13.32,13.32,0,0,1,2.73-.46,12.94,12.94,0,0,1,7.1,1.65c6.53,3.64,8.6,11.17,7.88,18a39.88,39.88,0,0,1-6.35,17.63c-3.83,5.62-8.58,8.85-14.59,11.88-13.65,6.88-29.24,5.34-44.19,7.69-6.67,1-13.39,1.94-20,3.46-64.12,14.84-118,64.23-138.5,127.84-17.48,54.35-11,115.27,13.05,166.59a245.42,245.42,0,0,0,21.5,37,238.38,238.38,0,0,0,28.45,33.54c10.4,10.15,22.33,18.54,34.23,26.92,21.27,15,56.4,30.5,81.29,22.77,13.9-4.32,8.09-24.5-9.17-13.56-5,3.19-9.25,9.75-11.41,15.32-2.95,7.64-2.44,13.87-1.48,20.89a43.72,43.72,0,0,0,6.1,17.19,39.43,39.43,0,0,0,20.1,16,61.69,61.69,0,0,0,20.82,3.38c47.31.26,66.23-5,70.9,5.77,4.52,10.34-18.5,34.15-18.5,54.72,0,3.58-2.45,3.45-2.75,1.79-.14-9.3,15.46-36.64,18.54-42.43-1.62,2.8,4.66,4.31,15.78,3.92s17.85-1.09,15.24,4.31c-2.51,5.17-21.68,43.41-18.9,71.53a4.25,4.25,0,0,1-3.79,4.66h-.08c-15.23,1.24-46.59-4.25-54.42-19.82-8.66-17.18,2.74-19.53,3.57-24.2s-8.31-1.61-1.65,4.12c10.85,9.35,25,3.63,25-.36,0-8.76-10.72-7.2-36-6.23-18.19.69-29.13,1.46-41.92-2.68a23,23,0,0,1-15.92-23.3c1.72-28,8-59.71,12.77-59.94s-5.15,30.52-11.25,64.41A304.82,304.82,0,0,1,292.19,1786c-51.9,118.24-107,110.29-139.91,155.91a95.15,95.15,0,0,0-11.75,88.55c8,21.62,23,40,45.7,50.34,30.37,13.86,63.69,9.31,94.64,0,28.68-8.62,56.1-23.2,86.27-26.13,63.08-6.12,107.56,52.95,104.35,112.11l-.05.91a114.87,114.87,0,0,1-2.79,19c-4.31,18.39-8.88,25.19-17.71,35.13A33.6,33.6,0,0,1,436.13,2232a35.38,35.38,0,0,1-15.62.75,55,55,0,0,1-31.77-16.77c-4.66-5-8.62-12.59-2.78-18.34a12.22,12.22,0,0,1,4.6-2.81c6.33-2.24,13.9-3,19.82,1.14a12.07,12.07,0,0,1,3.62,4c4,7.17-.68,14.65-5.65,20.3-4.31,4.85-9.07,9.35-12.66,14.74s-6,12-4.85,18.34c1.26,7,20,18.25,40.18,8.28,8.41-5.68,14.92-10.61,12.47-20.45a5.52,5.52,0,0,0-2-3.45,5.69,5.69,0,0,0-3-.66c-4.31,0-8.62.86-12.87.28-3.64-.5-7.06-2-10.71-2.42-2-.25-4.5-.37-6.12,1.07a10.63,10.63,0,0,0-2.06,3.45,12.45,12.45,0,0,1-2.31,3,7.75,7.75,0,0,1-6.72,2.37c-6.63-1-10.11-10-16.82-10.34-1.61-.07-3.45.33-4.69-.68a4.89,4.89,0,0,1-1.32-2.16,64.39,64.39,0,0,1-4.73-21.33,38.35,38.35,0,0,1,5.17-21c3.4-5.6,9.6-10.52,16.38-7.57a12.44,12.44,0,0,1,5.84,5.51c4.31,7.76,1.57,17.24-3.22,24.48-4.47,6.74-10.64,12.21-15.45,18.72s-8.33,14.77-6.32,22.61c1.65,6.47,6.89,11.6,12.93,14.44s12.85,3.68,19.54,4c12.63.5,25.72-1,36.71-7.27s19.52-17.84,19.43-30.48c-.06-7.75-3.29-15.22-7.86-21.49-2.83-3.88-6.65-7.6-11.44-8s-8.89,2.62-12.06,6c-5.84,6.15-9.71,15.34-6.43,23.16,1.1,2.64,2.95,5,3.14,8a4.9,4.9,0,0,1-1.31,3.81c-2.58,2.59-6.76.37-8.61-2.52-1.73-2.59-2.65-5.64-4.81-7.92-2.9-3-6.79-1.72-9.06,1.35a17.2,17.2,0,0,0-2.95,6.62c-.4,1.92-1.46,4.93-3.76,5.17s-4.53-1.18-6.9-1.35c-5.48-.41-9.16,5.88-14.5,7.19-3.35.87-6.89-.46-9.87-2.18a11.08,11.08,0,0,1-3.63-3c-2-2.71-1.6-6.49-.36-9.59,3-7.44,10.26-12.43,17.84-15.06s15.68-3.33,23.56-4.87,15.9-4.11,21.68-9.69c3.05-2.94,5.43-6.89,5.36-11.13a13.35,13.35,0,0,0-6-10.46,10.56,10.56,0,0,0-2.15-1.08,17.63,17.63,0,0,0-14.37.86c-20.77,10.69-17.41-2-43,4.9-13,2.64-25.85,7.41-36.91,35.92a62.31,62.31,0,0,0-4,17.61c1.49,30.36-8.17,40.17-8.88,48.26a4.36,4.36,0,0,0,1.47,3.5,6.14,6.14,0,0,0,7,1c9.21-4.55,10.17-.21,14.25-2.54.69-.4,2.07-3.56-.87-3.56a4.26,4.26,0,0,0-4.14,3.91c-1,11.26,10.34,46.37,33.14,55.74,31.28,12.84,73.12.4,85.52-30.65a65.81,65.81,0,0,0,4-30.22c-.24-2.59-.47-12.28-3.27-13.88-10.63-6.09-8.35,33.3-8.05,36.58,1.87,20.43,5.77,41.74,17.34,59.11a179.49,179.49,0,0,0,46.93,47.33c48.38,26.11,106.21,60.81,129.86,112.58,24.62,53.9,15.9,130.76-23.12,174.74-44.37,50-124.16,65.85-188.25,77.68q-5.4,1-10.83,1.86-2.88.45-5.72,1.12c-8,1.87-14.42,4-19.36,7a11,11,0,0,0-3.94,4c-15.37,28.06,134.64,41.42,113.53,28.47-14.3-8.77-86.5-19.6-142.74-13.33-29.48,3.28-54.57,11.27-64.63,26.71-29.3,44.91,195.73,93.54,221.13,59.67s-161-36.19-242.34,4.77,233.38,68.89,236.71,46.28-215-46.28-255.21,19.08S491,3061,517.07,3029.3s-241.62-61.63-264.83,5.26,158,82.56,172,57c13.29-24.34-132.55-41.78-104.47-110.11a59,59,0,0,1,15-21c14.39-13.16,25.43-14.65,36.59-16.26,13.09-1.92,27.06,2,38.33,8.92,1.65,1,3.39,2.37,3.51,4.31.2,3.11-4,3.78-6.8,5.17-11.32,5.46-12.6-12.15-21.13-10.67-2.66.46-8.48,3-5.45,19.75a20.19,20.19,0,0,1-3.67,15.59c-2.24,3-4.48,6-4.94,7.94-1,4.23,0,9.78,4.22,11.06,2.72.86,6.29-.31,8.09,1.87,1.14,1.37.91,3.41,1.65,5,1.35,2.94,5.62,3.44,8.48,1.94s4.64-4.46,6.27-7.25l7-11.91c4.18-7.13,7.47-17.31,6.52-25.5-.25-2.14-.86-4.27-.56-6.4s1.87-4.3,4-4.3c1.86,0,3.35,1.47,4.53,2.89,13.79,16.61,20.58,34.88,17.33,56.11a54.13,54.13,0,0,1-5.9,16.38c-1.11,1.85-2.58,4.55-4.06,6.77a1.2,1.2,0,0,1-2.18-.86c1-5.73,1.15-12.59-1.1-17.08-1-2-2.4-4-4.54-4.56-3.83-1.06-7.23,2.93-8.25,6.74s-.91,8.07-3.19,11.29c-2,2.8-5.44,4.24-8.86,4.59a24.56,24.56,0,0,1-4.85-.07c-1.25-.13-3.05-.86-4.23-.77-2.35.21-2.86,3.55-1.92,5.27,1.08,2,3.32,3,5.47,3.68s4.45,1.22,6.16,2.69c1.31,1.11,2.2,2.71,3.68,3.59,2.44,1.45,5.68.44,7.87-1.35s3.72-4.26,5.72-6.26a11.71,11.71,0,0,1,3.66-2.53,1.46,1.46,0,0,1,1.64,2.32,55.52,55.52,0,0,1-18.55,14.33c-3.27,1.53-6.2,3.13-10.26,4a4.85,4.85,0,0,1-3.66-.6c-4.38-2.81-6.63-9.14-8-14.23-.59-2.22-1.22-4.53-2.74-6.27s-4.18-2.72-6.2-1.61a7.4,7.4,0,0,0-3.58,4.08,4.78,4.78,0,0,0,1.08,4.64c1.15,1.56,4.42,2.41,4.92,1,.68-1.9-2.3-2.87-4-1.79-3.19,2-.79,5.72,1.14,7.68,2.92,3,6.94,4,10.67,5.72a2.09,2.09,0,0,1,1.26,2.13,2,2,0,0,1-1.84,1.73,79.26,79.26,0,0,1-21.84-1.42c-5.17-1.16-8.88-6-9.94-11.14-1.13-5.47,2.33-11.05,5.73-15.1a28.77,28.77,0,0,0,3.83-5.87c1.44-2.95,3.61-7.23.39-9.35-2.81-1.86-7.4,5.09-9-.38a8.19,8.19,0,0,1,2-7.25c10.65-10.54,11.51-23.62,7.26-35.91-2.22-6.41-6.22-12.71-12.54-15.29-4.74-1.94-6-3.45-8.81-2.72a6.45,6.45,0,0,0-4.49,4.3c-7.09,22.35-11.2-5.59-17.75,13.6-1.85,5.42,2.78,11.65,8.13,13.79,3.81,1.54,6,1.21,10.19,1s9,1,10.5,4.78c1.18,3-.44,6.56-3,8.56s-5.88,2.75-9.11,3.27a85.39,85.39,0,0,1-11.84,1.06c-10.9.14-11.1-12.51-8.87-20.08.39-1.33,1.13-2.2,2.59-2,1.72.2,2.23,2.49,2.19,4.24-.15,6.12-4.31,15.52-4.07,21.62-.25,8.29,8.16,24,12.41,28.44,5,5.17,13.15,12,19.49,14.71.53.23,2.32,1.06,4.75,2.26a1.9,1.9,0,0,1,.85,2.53,1.84,1.84,0,0,1-.85.85c-3.95,2-11.68,4.38-12.59,10.28a10.62,10.62,0,0,0,.74,5.68c3.88,9.18-3.34,12.63-2.33,23.33a25.94,25.94,0,0,0,3.25,10.06c22.4,40.7,86.1,36.31,86.1,36.31,15.1-.47,35.44-7.76,42.54-22.8,4.22-8.93,4.58-23-8.31-24.13-13.16-1.13-18,11.8-13.22,23.39,4.14,10,22.2,21.33,28.19,23.84,32.08,13.44,74.12-13.42,103.33,3.36,131.52,75.47,74.76,337.47-25.26,386.62-30.46,15-69.45,22.69-97.77,1.67-11.69-8.69-22.94-21.92-20.14-38.69,2.63-15.75,21.25-22.4,32.45-14.18,15.12,11.09,6.32,38.89-12.31,52.87-18.39,13.81-149.31,21.61-180.83,54.87-23.53,24.83-2.39,64.82,30.67,56l.44-.12a48.54,48.54,0,0,0,16.71-7.85,42.81,42.81,0,0,0,8.83-9c1.91-2.58,4.44-5.93,5.12-9.17.22-1-.31-2.36-1.72-2a1.91,1.91,0,0,0-.78.42,8.86,8.86,0,0,0-2.64,4.71c-.63,2.28-1.37,4.54-1.92,6.85-.86,3.49-2.48,9.15-.43,12.51a3,3,0,0,0,2.42,1.5c4.93,0,10.92-10.25,13.79-13.19a1.21,1.21,0,0,1,2.06.76c.06.72-.06,1.59-.06,2.26-.48,5,2.37,10.44,5.29,6.12s4.72-11.14,5.79-14c1.19-3.15,4.22-4.17,6.17-3.3s3,1.88,5.17,3c2.73,1.44,5.45,1.18,7.33-1.72s5.34-6.71,8.86-3.9-.63,15.89-7.05,17.61-6.09-5.3-5.36-7.48S378,3637,380,3639c4.58,4.56,13.53,3.23,18.88.77s8-4.49,8.69-7-2.11-5.72-3.45-.64-5.43,19.12.61,19.93a4.16,4.16,0,0,0,2.77-1.54,14.59,14.59,0,0,0,1.32-1.62,36.5,36.5,0,0,0,2.64-4.58c.57-1.15.9-2.53,1.85-3.45a1.82,1.82,0,0,1,1.65-.62,1.44,1.44,0,0,1,1,1.36,9.77,9.77,0,0,1-.36,2.14,15,15,0,0,0-.25,2c0,1.12.09,2.59,1.25,3.15s4.51,1.25,7.76-7.76,10.23-10.24,15.28-7c6.67,4.27,4.93,11.57,22.85,15.81,69.67,16.6,63.72-17.06,62.51-20.38-6.26-17.18-29.16-11.57-39-5.23-11.74,7.55-22.93,23.92-24.34,38-.06.65-.12,1.3-.17,2A37,37,0,0,1,441,3695a84.7,84.7,0,0,1-30.05,8.29c-8.41.69-19.3,1.53-34.32,2.74-38,3-97.87-12.53-101.84,45.83-.65,9.68,1.61,15.86,3.23,21.55,10.19,26.77,30.67,43.09,61.4,57.63,0,0,6.63-3.45,5-6.61-.94-1.56-6.59,3.45-4.7,11.64s.46,25.7,4.81,30.8c3.55,4.19,23.45,23.89,26.59,33.61s6.59,16.37,12.25,11.94,9.42-23.27-3.77-42.11.31,1.25,2.83-1.89,7-16.37,4.13-18.55-6.45,14.46-2.12,20.69c3.67,5.43,8.39,5.66,10.51,4.6.82-8.31,9.91-9,13-7A8.94,8.94,0,0,1,412,3876c-.35,8.69-15.51,11.48-17.1-.86-6.19-3.24-6.9-10.26-3.78-13.91,5.07-5.34,17-1.84,14.14,6-.74-.22-1.94-9,6.24-10.78,13.66-2.25,14.84,17.14.65,17,2.88,4.48,1.72,8.62,7.58,9.85,21.76,4.53,33.37,7.67,41.37,8.56,4.24.52,6.64,1.06,8.26,1a2.5,2.5,0,0,0,2.43-2.44c.42-11.73-39.84-13.07-46.73-17.75-.48-2.72,34.87,7.33,44.45,5.69a2.87,2.87,0,0,0,2.41-2.85c0-4.07-2.77-7.65-9-9.38l-.52-.13v-.11c0-.47-2.81-10.28-1.4-12.6,1.07-1.72,1.47,7.6,1.4,12.71-9.09-2.31-23.27-1.73-29.5-8.42-7.2-7.76-12-3.27-9.86-1.58a1.75,1.75,0,0,0,1.39.27c5-1.11.92-7.72-1.72-10.64a4,4,0,0,0-4.59-1c-3.45,1.61-7.34,4.64-5.58,5.72a1.73,1.73,0,0,0,1.49.09c3.57-1.39,9.37-6.67,3.44-11.11-6.28-4.71-15.07-19.82-17.58-24.84s-16.8-11.94-21.27-8.79,8.2,16.42,6.16,17.56c-5,.31-15.75-23.11,0-18,3.09-1.23-27-20.9-20.68-37.58,4.12-10.17,16.1-12.92,20.5-5.38,4,6.9,2.45,12.15.52,11.61a1.09,1.09,0,0,1-.7-.66c-2.46-9.05,15.56-15.88,17.68-.86,1.9,11.41,2.78,29.36.42,35.47a1.46,1.46,0,0,1-2.82-.46c-.39-6.89,4.93-26.64,2.4-35,6.15-1.91,25.48-2.72,35.46-5.62a1.67,1.67,0,0,1,2.07,1.14h0a2.25,2.25,0,0,1,.06.36c.22,4,.91,7.18.38,8.24-.63,1.26-8.76,4.51-8.92,1.68.18-4.46,7.7-3.61,13.35,1.42s14,7.9,20.89,13.1c2,2.23,10.43,13.1,14.42,23.09a11.1,11.1,0,0,1,.7,2.66c1.87,12.58,5.47,28.87,7.6,32.75,2.94,5.29-5.53,6-7.8,5.23-6.89-2.34-12.06-8.14-15.39-14.42-3.71-6.94-3.52-15.16-7.19-22.08a28.36,28.36,0,0,0-8.47-9.33.86.86,0,0,0-1.25,1.14,23.42,23.42,0,0,0,3.9,4.24c5.82,5.65,8.51,13,10.88,20.76A64,64,0,0,0,467,3846a33.74,33.74,0,0,0,4.06,5.17c2.31,2.34,6.27,3.83,9.31,5.5.58,3.7.47,9.07.6,12.83.14,4.14.74,10.86-.23,16-1.29,6.73-5.76,22.9-9,28.73a3.24,3.24,0,0,1-4.06,1.38c-3.83-1.65-3.95-5.85-5.08-8.27-26-1.88-62.29-13.92-65.44-14.92-4-1.24-4.85,1.64-.75,2.86a6,6,0,0,0,2.27.13c5.55-.65,9.3-4.92,11.11-7.85a6.9,6.9,0,0,1,7.39-3.06s25.18,7.4,36.45,8.8c6.23,1.12,19,3.94,18.32,10.84-.25,2.64-2.87,3-9.35,3.2,0,0,3.11,4.89-6.72,17.64-.9,1-5,6.65-6.68,6.9-3.44.55-5.34-5.86-5.12-8.75a4,4,0,0,1,3.3-3.37c4.8-1,11-1.54,12.38-7.6.78-3.72-1.82-6.21-2.09-1.53,0,7.17-11,5.25-13.72,7.7-2.47,1.31-2.31,4.66-1.78,7.24a2,2,0,0,1-.71,2c-.79.58-15.67,4.82-15.46-.64a12.23,12.23,0,0,1,3.61-7.76,9.86,9.86,0,0,1,9.35-2.58c1.34.33,2.42,1,2.58,2.1.23,1.72-10.17.21-15.16-.6a190.77,190.77,0,0,1-21.12-4.65c-8-2.24-13.61-5.17-16.48-6-3.6-1-1.55,6.89-1.14,7.88a79.92,79.92,0,0,0,9.34,16.21c12.4,17.12,49,29.26,68,38.59,68.1,33.49,138.72,78.84,177.83,146.08,30.17,51.86,37.73,130.23-14.06,171.51-23.17,18.47-53.44,25.46-82.94,28.37-52.17,5.14-143.85,8.69-195.79,16.54-32,4.84-67.31,9-97,22.81-73.79,34.39-125.93,119-80.16,196.29,16.73,28.26,42.61,52.5,69.32,71.28,25.64,18,53.28,33.07,81.33,47,22.86,11.35,127.15,71,153.07,48.47,16-13.89,12.66-47-13.31-43.48-17.66,2.42-36.19,14.34-48.85,26.54-18,17.35-35.46,39.64-61.61,44-9.1,1.53-22.33,4.78-44.06-1.63-17.87-5.28-27.68-26-7.05-31,8.18-2,17.71.52,24.82,4.48,25.85,14.41,27.52,51.38,52.45,63.77a34.26,34.26,0,0,0,8,2.69c23.16,5,19.67,9.73,19,12.12s-9-5.46,5.22-11.92,30.33,2,31.08,15.41-17.15,26.6-24.62,12.68,1-16.38,3.24-11.93,11.2,12.44,2.73,31.82-39.86,30.07-51.05.25c0,0-.57-4.83,2.7-4.59,1.24.09,2.22.61,2.72,3.26.49,3.45-5,3.92-5.42,1.33-3-6.53-5.25-29.24,11.77-39.52,16.13-9.75-12.26-3-9,.5,2.25,2.23,5.42-5.06,1.22-9.7-6.3-6.53-17.79-8.39-27.4,4.09-9.94,14.47,6,26.49,9.28,21.76s3-10.44.25-6-6,21.21,4.23,34.8c13.08,16.8,27.78,10.55,31.72,16.8,5.62,9.24-2.76,31.68-9,49.12-3.61,10.16-2.39,17-6,16.79-4-.24,1.44-5.9,1.22-1.33-.13,2.72-2.93,11.52-1.24,21.62a19.17,19.17,0,0,0,28.71,13.8c5.55-3.1,10.38-6.55,10.26-8.47-.19-3.21-37,25.66-51.2,36.9a28.86,28.86,0,0,0-10.59,17.7c-1.55,9.18.44,26.21,21.85,25.26,38-1.65,14.17-50.52-8.12-42.09s-18,44.1,8.12,42.09c17.24-1.32,19.55-11.85,19.55-11.85l26.58-38.74c5.68-8.3,7.7-18.3,7.15-28.34-1.57-28.67-12-78.54-14.34-80.86-.41,2.49,9.29,51,16.38,90.74,1.77,10,13.23,15.29,22.85,12.13,6-1.95,10.63-6.81,11.26-16.12,1.19-18-26.36-43.51-51-101.06a5,5,0,0,0-5.86-2.78c-5.17,1.57-12.46,6.46-22.4,5.81a7.63,7.63,0,0,0-7.76,5.17c-3.22,9.48-6.68,25.19-10.5,35.47-4.08,10.91-24.61,50.56-18.89,55.28,3.25,2.68,12.21.22,16.19-6.25.86-3.88,7-28,18-77.56.05-.25-.25-.45-.5-.47-1.9-.15-7.39,18.22-16.47,71.08a16.22,16.22,0,0,0,1.38,10.12c3.45,6.77,8.26,14.94,10,12.41.47-.67.32-1.93-.22-3.5a15.51,15.51,0,0,0-19.73-9.58,14.91,14.91,0,0,0-3.17,1.52c-14.65,9.05-37.4,23-48.34,28.93-17.16,9.25-5,51.89,22.41,32.05,15.6-11.75,1.14-34.48-7.16-35.56-7-1.48-29,2.51-20.13,30.9,12.27,32.7,69.4-29.82,72.88-37.29s-30.47,7.53-33.81,44.75c-6.14,68.44,72.44,105.55,128.1,116.56,36.43,7.2,74.29,6.78,109,21.1,57.89,23.86,97.23,74,108.47,135.44,8.67,47.31-1.78,91.24-25.85,126.5-25.21,36.93-61.44,68.88-103.11,85.77-46,18.66-95.44,7.47-141.66-5.81-47.13-13.53-125-41-155.84,16.57-17,31.89,7.36,67.82,42.46,67.82l4.82-3.1,5.77,6.29,4.75-5.86,2.91,45.67,4.82-86,5.51,48.06,4.48-8.91,4.13,5h19l4.83-3.45,5.77,6.68,4.75-5.86,2.9,44.53,4.83-86,5.51,48.06,4.48-8.92,4.12,5h20.9l4.82-3.45,5.78,6.68,4.74-5.86,2.83,44.38,4.82-86,5.51,48.06,4.47-8.92,4.14,5.05h7.64c14.18,0,31.25,6.11,37.39,20.5,6.42,15,6.13,32.88-13.14,50.9a66.7,66.7,0,0,1-31.5,16.37c-44.45,9.67-87.32,9.39-132.84.5-19.2-3.74-38-10.94-51.87-22.92-11.8-10.19-13-30.43-2.87-33,33.24-8.31,25.12,49.12-.57,76-9.11,9.47-26.07,24.47-37,30.63-9.69,5.48-18.75,10.34-28,14.74-39,18.49-68.08,53.26-78,95.29-24.69,129.53,61.73,205,199.63,216.72,86.73,7.35,192.3-45.1,255.18-2.23,83.3,56.79,59.17,292-138.09,350.9a106.48,106.48,0,0,1-74.59-5c-15.51-7.08-30.89-17.08-34.47-32.75-10-43.41,57-29.51,24.13-.57-6.84,6-134.62,109.62,11.9,130.83,14.56-1.29,28.52,12.8,22.62,27.44-2.23,5.54-7.83,8.74-13.63,9a18.14,18.14,0,0,1-13.3-4.59c-11.14-9.18-4.65-21.3-.6-24.32,3.17-1.1-.59,10.63,4.87,10,3.12-.35,6.14-4.64,9.28-2a4.51,4.51,0,0,1,1.46,2.24,3.82,3.82,0,0,1,0,2.54,3.38,3.38,0,0,1-3.69,1.72c-7.47-1.21-10.27-13.22-4.14-17.6,4.61-3.29,7.62-5,19.06,1.72,12.93,7.6,11.69,28.06,17,28.57,5.31-.51,4.08-21,17-28.57,11.44-6.73,14.45-5,19.07-1.72,6.11,4.38,3.32,16.37-4.16,17.6a3.38,3.38,0,0,1-3.69-1.72,3.84,3.84,0,0,1,0-2.59,4.66,4.66,0,0,1,1.45-2.22c3.15-2.58,6.17,1.72,9.28,2,5.47.61,1.32-12.39,4.48-11.29,4.05,3,11,16.37-.19,25.58a18.18,18.18,0,0,1-13.25,4.65c-5.8-.28-11.39-3.45-13.62-9-5.91-14.65,8.05-28.72,22.62-27.44,18,1.59,31.56-.36,41.54-4.8a1.77,1.77,0,0,0-1.13-3.35c-3.44.78-7.22,1.52-10.44,1.91-3.92.48-9.48.33-12,4-3.63,5.13-1.65,11.25-.12,16.71,1.67,5.94,3.62,11.88,3.92,18.1a37,37,0,0,1-5.55,21.09c-4.69,7.41-13.06,10.8-21.65,10.34a41.23,41.23,0,0,1-19-5.81c-4.69-3-8.49-8-14.59-7.76-14.78.43-18.58,18.27-36.44,12.61-20.19-6.41-46.91-42.95-5.82-80.94,65.58-50.44,122.42,21.92,126.79,86.6,3.72,55,0,93.47-7.65,113.21-.51,1.31-1.65,5.08-3.63,4.74-2.72-.45-3.71-9.6-4.13-11.51-1.51-7-2.79-14.12-4.91-21-5.17-16.69-20.6-27.49-26.33-44.08-3.16-9.17-6.35-21.69-1.8-30.79,3.8-7.63,13-12.76,21.3-13.34,7.55-.55,13.93,3.31,17.43,9.92,6.42,12.11,7.76,27.57,7.47,41.08-.66,29.93-6.89,59.91-13.29,89-.86,4-1.77,8-2.74,12.27-1.26,5.54-6.93,5.48-8.68-.21q-1.73-5.7-3.78-11.11c-10.12-27-31-41.36-49.41-45-43.09-8.61-78.09-70.15-70-113.75s-87.36,15.11-72.43,98.36c11.2,62.43,54,80.53,94.23,93.06,11.49,3.54,30.87,6.85,44.81,9a242.23,242.23,0,0,0,28.83,2.63c298.77,9.47,278.14,219.92,166.4,333.48-57.32,58.24-143.59,76.48-220.52,48.9C365,7111.78,340.3,7104.6,321.7,7107a17.37,17.37,0,0,0-13.19,10c-4.08,9.48,2.88,17.07,9.86,22.61,9,7.16,19.43,12.32,28.05,20a11.38,11.38,0,0,1,3.92,8.5c-.07,11.64-15.29,12.25-23.6,12.5-15.39.46-30.68-1.63-46-3.1a212.43,212.43,0,0,0-45.72.86c-72.5,8.17-129,114.9-124.57,220.38,5.09,120.44,91.78,203.52,245.32,187.84,20.6-2.1,42.69-2.83,62.69,3.33,10.88,3.35,21.74,10.13,27.3,20.33,6.12,11.2-1.16,24.44-10.57,31.11-16.86,11.93-37.59,14.13-57.47,16.93-22,3.11-38.14,1.9-58.77,16.38-6.89,4.83-11.06,12.06-13.13,20.28-11.31,44.63,36,74.11,78.17,55.73,8.85-3.85,17.74-10.08,26.34-19.16,37.28-45.43-27.39-52.47-27.39-25-.86,6.52,5.63,7.2,5.78,0,1.49-12.61-31.51-31.17-39.4-2.63-6,31.12,56.2,71.1,115.09,37.78';

const LINE_MAP = [
  {
    // start
    scroll: 0,
    size: DESKTOP_ANIMATION_OFFSET,
    offset: DESKTOP_ANIMATION_OFFSET,
    width: 3,
  },
  {
    // halt
    scroll: 0.03,
    size: 100,
    offset: 200,
    width: 3,
  },
  {
    // amount start
    scroll: 0.054,
    size: 3800,
    offset: 4500,
    width: 3,
  },
  {
    // amount shorting
    scroll: 0.06,
    size: 4000,
    offset: 4800,
    width: 3,
  },
  {
    // amount end
    scroll: 0.0751,
    size: 1000,
    offset: 6400,
    width: 3,
  },
  {
    // gap deccelarate
    scroll: 0.078,
    size: 1500,
    offset: 7000,
    width: 7,
  },
  {
    // gap deccelarate again
    scroll: 0.085,
    size: 800,
    offset: 7500,
    width: 3,
  },
  {
    // bottle start
    scroll: 0.1,
    size: 1500,
    offset: 8500,
    width: 3,
  },
  {
    // bottle
    scroll: 0.11,
    size: 2000,
    offset: 9500,
    width: 3,
  },
  {
    // bottle completion
    scroll: 0.12,
    size: 2300,
    offset: 10000,
    width: 3,
  },
  {
    // bottle end
    scroll: 0.125,
    size: 3000,
    offset: 10500,
    width: 3,
  },
  {
    // accelerate
    scroll: 0.137,
    size: 600,
    offset: 10700,
    width: 6,
  },
  {
    // accelerate more
    scroll: 0.18,
    size: 300,
    offset: 11100,
    width: 8,
  },
  {
    // accelerate even more
    scroll: 0.19,
    size: 100,
    offset: 12000,
    width: 10,
  },
  {
    // decelerate even more
    scroll: 0.2,
    size: 500,
    offset: 12500,
    width: 6,
  },
  {
    // flag start
    scroll: 0.22,
    size: 2000,
    offset: 14500,
    width: 3,
  },
  {
    // flag
    scroll: 0.23,
    size: 2900,
    offset: 15500,
    width: 3,
  },
  {
    // go to head first
    scroll: 0.26,
    size: 1400,
    offset: 16000,
    width: 7,
  },
  {
    // go to head
    scroll: 0.27,
    size: 500,
    offset: 16200,
    width: 3,
  },
  {
    // go to head middle
    scroll: 0.28,
    size: 1200,
    offset: 17000,
    width: 3,
  },
  {
    // head
    scroll: 0.31,
    size: 3400,
    offset: 19400,
    width: 3,
  },
  {
    // accelerate from head
    scroll: 0.33,
    size: 3300,
    offset: 19800,
    width: 3,
  },

  {
    // loop decelerate
    scroll: 0.34,
    size: 500,
    offset: 21000,
    width: 6,
  },
  {
    // swirl first
    scroll: 0.36,
    size: 100,
    offset: 21500,
    width: 3,
  },
  {
    // swirl second
    scroll: 0.37,
    size: 200,
    offset: 22500,
    width: 10,
  },
  {
    // swirl third
    scroll: 0.38,
    size: 100,
    offset: 23000,
    width: 3,
  },
  {
    // swirl fourth
    scroll: 0.39,
    size: 200,
    offset: 24000,
    width: 10,
  },
  {
    // swirl fifth
    scroll: 0.4,
    size: 100,
    offset: 25000,
    width: 3,
  },
  {
    // swirl last
    scroll: 0.41,
    size: 300,
    offset: 25900,
    width: 14,
  },
  {
    // earth
    scroll: 0.42,
    size: 1000,
    offset: 27000,
    width: 3,
  },
  {
    // earth
    scroll: 0.43,
    size: 4000,
    offset: 30500,
    width: 3,
  },
  {
    // earth end
    scroll: 0.44,
    size: 4500,
    offset: 31000,
    width: 3,
  },
  {
    // before wow
    scroll: 0.47,
    size: 2000,
    offset: 31500,
    width: 3,
  },
  {
    // wow
    scroll: 0.48,
    size: 2000,
    offset: 33000,
    width: 3,
  },
  {
    // wow accelerate
    scroll: 0.5,
    size: 600,
    offset: 33300,
    width: 7,
  },
  {
    // before hand
    scroll: 0.53,
    size: 1000,
    offset: 33800,
    width: 3,
  },
  {
    // hands
    scroll: 0.58,
    size: 4000,
    offset: 38200,
    width: 3,
  },
  {
    // hands end
    scroll: 0.59,
    size: 4000,
    offset: 38450,
    width: 3,
  },
  {
    // accelerate
    scroll: 0.6,
    size: 300,
    offset: 39100,
    width: 6,
  },
  {
    // accelerate more
    scroll: 0.63,
    size: 150,
    offset: 40000,
    width: 12,
  },
  {
    // accelerate more
    scroll: 0.635,
    size: 50,
    offset: 40100,
    width: 3,
  },
  {
    // stop
    scroll: 0.638,
    size: 50,
    offset: 40120,
    width: 3,
  },
  {
    // drop
    scroll: 0.642,
    size: 50,
    offset: 40200,
    width: 3,
  },
  {
    // stop
    scroll: 0.65,
    size: 50,
    offset: 40270,
    width: 3,
  },
  {
    // stop halt
    scroll: 0.66,
    size: 10,
    offset: 40450,
    width: 3,
  },
  {
    // bear
    scroll: 0.69,
    size: 5550,
    offset: 46050,
    width: 3,
  },
  {
    // drop
    scroll: 0.72,
    size: 2000,
    offset: 47500,
    width: 3,
  },
  {
    // beat
    scroll: 0.79,
    size: 2650,
    offset: 50000,
    width: 3,
  },
  {
    // beat drop
    scroll: 0.795,
    size: 1200,
    offset: 50500,
    width: 5,
  },
  {
    // beat drop more
    scroll: 0.84,
    size: 600,
    offset: 51000,
    width: 6,
  },
  {
    // owl
    scroll: 0.87,
    size: 2200,
    offset: 53200,
    width: 3,
  },
  {
    // owl end
    scroll: 0.9,
    size: 4500,
    offset: 55700,
    width: 3,
  },
  {
    // end swirl
    scroll: 0.91,
    size: 1200,
    offset: 56300,
    width: 8,
  },
  {
    // end swirl two
    scroll: 0.915,
    size: 400,
    offset: 56500,
    width: 3,
  },
  {
    // end
    scroll: 0.92,
    size: 450,
    offset: 57000,
    width: 3,
  },
  {
    // very end
    scroll: 0.93,
    size: 480,
    offset: 57337,
    width: 1,
  },
  {
    // disappear
    scroll: 0.94,
    size: 291,
    offset: 57337,
    width: 0,
    color: COLORS.darkerPink,
  },
  {
    // end stuck
    scroll: 1 + Number.EPSILON,
    size: 291,
    offset: 57337,
    width: 0,
    color: COLORS.darkerPink,
  },
];

const MOBILE_LINE_MAP = [
  // start
  {
    scroll: 0,
    size: MOBILE_ANIMATION_OFFSET,
    offset: MOBILE_ANIMATION_OFFSET,
    width: 2,
  },
  // number start
  {
    scroll: 0.025,
    size: 1000,
    offset: 1100,
    width: 2,
  },
  // number end
  {
    scroll: 0.03,
    size: 1200,
    offset: 1400,
    width: 2,
  },
  // bottle start
  {
    scroll: 0.04,
    size: 1350,
    offset: 1600,
    width: 2,
  },
  // bottle midway
  {
    scroll: 0.05,
    size: 1000,
    offset: 2300,
    width: 2,
  },
  // bottle end
  {
    scroll: 0.06,
    size: 1200,
    offset: 2750,
    width: 2,
  },
  // out after bottle
  {
    scroll: 0.07,
    size: 1400,
    offset: 3000,
    width: 3,
  },
  // before in
  {
    scroll: 0.08,
    size: 100,
    offset: 3200,
    width: 3,
  },
  // in
  {
    scroll: 0.1,
    size: 100,
    offset: 3600,
    width: 4,
  },
  // in again
  {
    scroll: 0.15,
    size: 50,
    offset: 4300,
    width: 5,
  },
  // after swirl
  {
    scroll: 0.155,
    size: 100,
    offset: 4350,
    width: 2,
  },
  // flag
  {
    scroll: 0.18,
    size: 950,
    offset: 5300,
    width: 2,
  },
  // before head
  {
    scroll: 0.2,
    size: 250,
    offset: 5800,
    width: 2,
  },
  //  head
  {
    scroll: 0.21,
    size: 1400,
    offset: 6900,
    width: 2,
  },
  // leave head
  {
    scroll: 0.25,
    size: 1400,
    offset: 7400,
    width: 2,
  },
  // gone from head
  {
    scroll: 0.265,
    size: 500,
    offset: 7700,
    width: 4,
  },
  // towards world
  {
    scroll: 0.27,
    size: 200,
    offset: 7800,
    width: 2,
  },
  // swirl in
  {
    scroll: 0.275,
    size: 200,
    offset: 8000,
    width: 5,
  },
  // swirl out
  {
    scroll: 0.28,
    size: 100,
    offset: 8300,
    width: 2,
  },
  // swirl in again
  {
    scroll: 0.29,
    size: 100,
    offset: 8500,
    width: 6,
  },
  // swirl out again
  {
    scroll: 0.3,
    size: 100,
    offset: 8800,
    width: 2,
  },
  // swirl in before final
  {
    scroll: 0.31,
    size: 100,
    offset: 9120,
    width: 6,
  },
  // swirl out before final
  {
    scroll: 0.315,
    size: 100,
    offset: 9430,
    width: 2,
  },
  // last swirl
  {
    scroll: 0.32,
    size: 100,
    offset: 9730,
    width: 7,
  },
  // world
  {
    scroll: 0.33,
    size: 1200,
    offset: 11200,
    width: 2,
  },
  // world out
  {
    scroll: 0.348,
    size: 1000,
    offset: 11500,
    width: 2,
  },
  // world gone
  {
    scroll: 0.36,
    size: 400,
    offset: 12000,
    width: 4,
  },
  // in again
  {
    scroll: 0.38,
    size: 400,
    offset: 12500,
    width: 4,
  },
  // wow
  {
    scroll: 0.4,
    size: 1000,
    offset: 13500,
    width: 2,
  },
  // after wow
  {
    scroll: 0.41,
    size: 200,
    offset: 13600,
    width: 4,
  },
  // hands
  {
    scroll: 0.42,
    size: 1600,
    offset: 15300,
    width: 2,
  },
  // after hands
  {
    scroll: 0.44,
    size: 1500,
    offset: 15700,
    width: 3,
  },
  // gone from hands
  {
    scroll: 0.455,
    size: 500,
    offset: 16000,
    width: 3,
  },
  // in again
  {
    scroll: 0.46,
    size: 200,
    offset: 16200,
    width: 5,
  },
  // to bear
  {
    scroll: 0.49,
    size: 400,
    offset: 16800,
    width: 3,
  },
  // bear
  {
    scroll: 0.55,
    size: 2400,
    offset: 19400,
    width: 2,
  },
  // bye bear
  {
    scroll: 0.56,
    size: 1800,
    offset: 19700,
    width: 3,
  },
  // appear
  {
    scroll: 0.59,
    size: 200,
    offset: 20200,
    width: 3,
  },
  // beat
  {
    scroll: 0.61,
    size: 1000,
    offset: 21300,
    width: 2,
  },
  // out of beat
  {
    scroll: 0.62,
    size: 1330,
    offset: 21700,
    width: 3,
  },
  // in
  {
    scroll: 0.63,
    size: 500,
    offset: 22000,
    width: 3,
  },
  // out
  {
    scroll: 0.66,
    size: 500,
    offset: 22500,
    width: 4,
  },
  // loop de swhoop
  {
    scroll: 0.69,
    size: 200,
    offset: 22800,
    width: 4,
  },
  // pre owl
  {
    scroll: 0.7,
    size: 100,
    offset: 23100,
    width: 2,
  },
  // owl
  {
    scroll: 0.73,
    size: 2500,
    offset: 25600,
    width: 2,
  },
  // bye owl hoot hoot
  {
    scroll: 0.77,
    size: 500,
    offset: 26000,
    width: 3,
  },
  // in
  {
    scroll: 0.79,
    size: 200,
    offset: 26200,
    width: 2,
  },
  // to heart
  {
    scroll: 0.83,
    size: 400,
    offset: 27000,
    width: 2,
  },
  // end
  {
    scroll: 0.86,
    size: 245,
    offset: typeof window !== 'undefined' && window.safari !== undefined ? 27650 : 27685,
    width: 0,
    color: COLORS.darkerPink,
  },
  {
    // very end
    scroll: 1 + Number.EPSILON,
    size: 245,
    offset: typeof window !== 'undefined' && window.safari !== undefined ? 27650 : 27685,
    width: 0,
    color: COLORS.darkerPink,
  },
];

const SVGContainer = styled.svg`
  @media (min-width: ${GIVEBACK2019_DESKTOP_BREAKPOINT}px) {
    width: ${VIEW_BOX_WIDTH}px;
    height: ${VIEW_BOX_HEIGHT}px;
  }

  @media (max-width: ${GIVEBACK2019_MOBILE_BREAKPOINT}px) {
    width: 100vw;
    max-width: 768px;
    height: ${MOBILE_VIEW_BOX_HEIGHT}px;
  }
`;

const pathStyle = css`
  fill: none;
  stroke-miterlimit: 10;
  stroke-linecap: round;
  stroke-linejoin: round;
`;

const dotPopAnimationDesktop = keyframes`
    0% {
        stroke-width: 0px;
    }
    38% {
        stroke-width: 18px;
    }
    61% {
        stroke-width: 8.4px;
    }
    83% {
        stroke-width: 13.2px;
    }
`;

const dotPopAnimationMobile = keyframes`
    0% {
        stroke-width: 0px;
    }
    38% {
        stroke-width: 12px;
    }
    61% {
        stroke-width: 5.6px;
    }
    83% {
        stroke-width: 8.8px;
    }
`;

const dotSlideAnimationMobile = keyframes`
    0% {
        stroke-dashoffset: 0;
    }
    100% {
        stroke-dashoffset: ${-MOBILE_ANIMATION_OFFSET};
   }
`;

const dotSlideAnimationDesktop = keyframes`
    0% {
        stroke-dashoffset: ${BASE_OFFSET};
    }
    100% {
        stroke-dashoffset: ${BASE_OFFSET + DESKTOP_ANIMATION_OFFSET};
    }
`;

const pathSlideAnimationMobile = keyframes`
    0% {
        stroke-width: 0;
        stroke-dashoffset: 0;
        stroke-dasharray: 0 ${LARGE_ENOUGH_GAP};
    }
    1% {
        stroke-width: 8px;
    }
    100% {
        stroke-dashoffset: 0;
        stroke-dasharray:  ${MOBILE_ANIMATION_OFFSET} ${LARGE_ENOUGH_GAP};
   }
`;

const pathSlideAnimationDesktop = keyframes`
    0% {
        stroke-width: 0;
        stroke-dashoffset: ${BASE_OFFSET};
        stroke-dasharray: 0 ${LARGE_ENOUGH_GAP};
    }
    1% {
        stroke-width: 2px;
    }
    100% {
        stroke-dashoffset: ${BASE_OFFSET + DESKTOP_ANIMATION_OFFSET};
        stroke-dasharray: ${DESKTOP_ANIMATION_OFFSET} ${LARGE_ENOUGH_GAP};
   }
`;

const animationEasing = 'cubic-bezier(.31, 1.25, .38, 1.32)';

const SVGBackgroundPath = styled(SVGPathSegment)`
  ${pathStyle}
`;

const pathAnimation = css`
  @media (min-width: ${GIVEBACK2019_DESKTOP_BREAKPOINT}px) {
    animation: ${pathSlideAnimationDesktop} 1.5s ${animationEasing} backwards;
    animation-delay: 2.33s;
  }
  @media (max-width: ${GIVEBACK2019_MOBILE_BREAKPOINT}px) {
    animation: ${pathSlideAnimationMobile} 1.5s ${animationEasing} backwards;
    animation-delay: 2.33s;
  }
`;

const dotAnimation = css`
  @media (min-width: ${GIVEBACK2019_DESKTOP_BREAKPOINT}px) {
    animation:
      ${dotPopAnimationDesktop} 1.5s ease-in-out backwards,
      ${dotSlideAnimationDesktop} 1.5s ${animationEasing} backwards;
    animation-delay: 0.5s, 2.33s;
  }
  @media (max-width: ${GIVEBACK2019_MOBILE_BREAKPOINT}px) {
    animation:
      ${dotPopAnimationMobile} 1.5s ease-in-out backwards,
      ${dotSlideAnimationMobile} 1.5s ${animationEasing} backwards;
    animation-delay: 0.5s, 2.33s;
  }
`;

const SVGForegroundPath = styled(SVGPathSegment)`
  ${pathStyle}
`;

const SVGDotPath = styled(SVGPathSegment)`
  ${pathStyle}
`;

export default function SVGCompletePath({ relativeScroll }) {
  const [animationPlaying, setAnimationPlaying] = useState(relativeScroll === 0);
  const isMobile = isInGiveback2019MobileViewport();
  const vbWidth = isMobile ? MOBILE_VIEW_BOX_WIDTH : VIEW_BOX_WIDTH;
  const vbHeight = isMobile ? MOBILE_VIEW_BOX_HEIGHT : VIEW_BOX_HEIGHT;
  const baseOffset = isMobile ? MOBILE_BASE_OFFSET : BASE_OFFSET;
  const baseLineWidth = isMobile ? 2 : 3;
  const path = isMobile ? MOBILE_PATH : PATH;
  const lineMap = isMobile ? MOBILE_LINE_MAP : LINE_MAP;
  const index = lineMap.findIndex(({ scroll }) => Math.min(1, Math.max(0, relativeScroll)) < scroll);
  const fromBucket = lineMap[index - 1];
  const toBucket = lineMap[index];
  const relativeScrollInBucket = inversedLerp(fromBucket.scroll, toBucket.scroll, relativeScroll);
  const size = lerp(fromBucket.size, toBucket.size, relativeScrollInBucket);
  const trueOffset = lerp(fromBucket.offset, toBucket.offset, relativeScrollInBucket);
  const width = lerp(fromBucket.width, toBucket.width, relativeScrollInBucket);
  const offset = isMobile ? -trueOffset : trueOffset;
  const strokeColor = fromBucket.color ? fromBucket.color : COLORS.night;
  const rs = relativeScroll;

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (relativeScroll > 0 && animationPlaying) {
      setAnimationPlaying(false);
    }
  }, [relativeScroll]); // eslint-disable-line react-hooks/exhaustive-deps

  // NOTE: The duplication in `animationPlaying` is because
  // the `css` prop doesn't like an internal conditional :shrug:

  return (
    <SVGContainer
      xmlns="http://www.w3.org/2000/svg"
      width={vbWidth}
      height={vbHeight}
      viewBox={`0 0 ${vbWidth} ${vbHeight}`}
      preserveAspectRatio="xMidYMid slice"
    >
      {/* The negative `cil` indicate when the fill begins to fade */}
      {isMobile ? (
        <>
          <MobileSVGGradients />
          <MobileSVGBottle opacity={cil(0.05, 0.07, rs) - cil(0.08, 0.1, rs)} />
          <MobileSVGFlag opacity={cil(0.16, 0.18, rs) - cil(0.19, 0.21, rs)} />
          <MobileSVGHead opacity={cil(0.22, 0.25, rs) - cil(0.26, 0.27, rs)} />
          <MobileSVGWorld opacity={cil(0.32, 0.35, rs) - cil(0.35, 0.365, rs)} />
          <MobileSVGHands opacity={cil(0.41, 0.43, rs) - cil(0.44, 0.46, rs)} />
          <MobileSVGBear opacity={cil(0.54, 0.555, rs) - cil(0.56, 0.572, rs)} />
          <MobileSVGBeat opacity={cil(0.6, 0.61, rs) - cil(0.623, 0.65, rs)} />
          <MobileSVGOwl opacity={cil(0.71, 0.72, rs) - cil(0.74, 0.76, rs)} />
          <MobileSVGHeart opacity={cil(0.86, 0.87, rs)} />
        </>
      ) : (
        <>
          <SVGGradients />
          <SVGBottle opacity={cil(0.08, 0.11, rs) - cil(0.12, 0.14, rs)} />
          <SVGFlag opacity={cil(0.195, 0.215, rs) - cil(0.235, 0.255, rs)} />
          <SVGHead opacity={cil(0.28, 0.3, rs) - cil(0.315, 0.335, rs)} />
          <SVGWorld opacity={cil(0.41, 0.43, rs) - cil(0.44, 0.46, rs)} />
          <SVGHands opacity={cil(0.54, 0.56, rs) - cil(0.58, 0.6, rs)} />
          <SVGBear opacity={cil(0.67, 0.69, rs) - cil(0.7, 0.71, rs)} />
          <SVGBeat opacity={cil(0.74, 0.76, rs) - cil(0.77, 0.79, rs)} />
          <SVGOwl opacity={cil(0.86, 0.88, rs) - cil(0.9, 0.92, rs)} />
          <SVGHeart opacity={cil(0.93, 0.94, rs)} />
        </>
      )}
      {animationPlaying ? (
        <>
          <SVGForegroundPath
            css={pathAnimation}
            stroke={strokeColor}
            path={path}
            size={size}
            width={baseLineWidth}
            baseOffset={baseOffset}
            offset={isMobile ? offset + size : offset}
            color={strokeColor}
          />
          <SVGDotPath
            css={dotAnimation}
            path={path}
            size={1}
            width={width * DOT_SIZE_MULTIPLIER}
            baseOffset={baseOffset}
            offset={offset}
            color={COLORS.pink}
          />
        </>
      ) : (
        <>
          <SVGBackgroundPath
            path={path}
            size={isMobile ? -offset : offset}
            width={baseLineWidth}
            baseOffset={baseOffset}
            offset={isMobile ? 0 : offset}
            color={COLORS.glass}
          />
          <SVGForegroundPath
            stroke={strokeColor}
            path={path}
            size={size}
            width={baseLineWidth}
            baseOffset={baseOffset}
            offset={isMobile ? offset + size : offset}
            color={strokeColor}
          />
          <SVGDotPath
            path={path}
            size={1}
            width={width * DOT_SIZE_MULTIPLIER}
            baseOffset={baseOffset}
            offset={offset}
            color={COLORS.pink}
          />
        </>
      )}
    </SVGContainer>
  );
}
